import { useGetCTraderAccessQuery } from '../store/api/platformApi';
import { useCanVerify } from '../store/api/paymentVerificationApi';

/**
 * Nav rows that only some traders get carry a `gate` in nav.js — the name of
 * a flag here. Every place that draws the nav (sidebar, dock, search) filters
 * through the same hook, so a gated row can't show in one and not the others.
 */
export function useNavGates() {
  const { data } = useGetCTraderAccessQuery();
  const { canVerify } = useCanVerify();
  return {
    // Payment & Verification only for a trader the backend lets verify
    // (`can_verify`), as on the old dashboard.
    verify: canVerify,
    // Live's own test (SideBar/index.js on main), which accepts any of the
    // shapes the endpoint has answered with: a bare `true`, or one of these
    // flags set to true.
    ctrader:
      data === true ||
      data?.is_ctrader_user === true ||
      data?.is_ctrader === true ||
      data?.isCTrader === true ||
      data?.allowed === true,
  };
}

/** `items.filter(byGates(gates))` — rows without a gate always pass. */
export const byGates = (gates) => (item) => !item.gate || Boolean(gates[item.gate]);
